(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ark-faq-hub"] && !Shopify.designMode) return;
  try {
    
(function(){var i=document.getElementById('fh-q');if(!i)return;var root=i.closest('.ark-fh');
i.addEventListener('input',function(){var t=i.value.trim().toLowerCase();var any=false;
root.querySelectorAll('.fh-qlist li,details.fh-faq').forEach(function(el){var m=!t||(el.getAttribute('data-q')||'').indexOf(t)>-1;el.style.display=m?'':'none';if(m)any=true;});
root.querySelectorAll('.fh-topic').forEach(function(c){var vis=c.querySelectorAll('.fh-qlist li:not([style*="none"])').length;c.style.display=vis?'':'none';});
root.querySelectorAll('.fh-cat').forEach(function(s){var vis=Array.prototype.some.call(s.querySelectorAll('.fh-topic,details.fh-faq'),function(x){return x.style.display!=='none';});s.style.display=(t&&!vis)?'none':'';});
var emp=document.getElementById('fh-empty');if(emp)emp.style.display=(t&&!any)?'block':'none';});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-hub"] && !Shopify.designMode) return;
  try {
    
(function(){var i=document.getElementById('fh-q');if(!i)return;var root=i.closest('.ark-fh');
i.addEventListener('input',function(){var t=i.value.trim().toLowerCase();var any=false;
root.querySelectorAll('details.fh-faq').forEach(function(el){var m=!t||(el.getAttribute('data-q')||'').indexOf(t)>-1;el.style.display=m?'':'none';if(m)any=true;});
root.querySelectorAll('.fh-cat').forEach(function(s){var vis=Array.prototype.some.call(s.querySelectorAll('details.fh-faq'),function(x){return x.style.display!=='none';});s.style.display=(t&&!vis)?'none':'';});
root.querySelectorAll('.fh-mini-cta').forEach(function(x){x.style.display=t?'none':'';});
var emp=document.getElementById('fh-empty');if(emp)emp.style.display=(t&&!any)?'block':'none';});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
